import {
  initialState,
  Actions,
  State,
  EDIT_PAGO,
  EDIT_PAGO_SUCCESS,
  EDIT_PAGO_ERROR,
  RESET_EDIT_PAGO,
} from "../../types/pago/edit";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_PAGO:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case EDIT_PAGO_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case EDIT_PAGO_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      };
    case RESET_EDIT_PAGO:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
